import React, { useState } from "react";
import { Box, Typography, Container, CircularProgress } from "@mui/material";
import ChapterViewer from "./components/ChapterViewer";
import QuestionGeneratorButton from "./components/QuestionGeneratorButton";
import {
  generateQuestions, 
  gradeSingleAnswer,
  gradeAllAnswers,
  semanticEvaluate,
  langchainEvaluate,
  //resetCache,
  storeChapter,
} from "./api";
import QuizRotation from "./components/QuizRotation";
import FeedbackSummary from "./components/FeedbackSummary";
import Evaluation from "./components/Evaluation";
import { useEffect } from "react";


export default function App() {
  const [chapterText, setChapterText] = useState(
    "Once upon a time in a small village, there was a kind farmer..."
  );
  const [questions, setQuestions] = useState([]);
  const [answers, setAnswers] = useState({});
  const [grade, setGrade] = useState(""); 
  const [feedback, setFeedback] = useState({});
  //const [evaluationResults, setEvaluationResults] = useState({});
  const [evaluationResults, setEvaluationResults] = useState(null);
  const [evaluationSummary, setEvaluationSummary] = useState(null);
  const [evaluationType,setEvalutionType] = useState(null);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [showSummary, setShowSummary] = useState(false);  

  const [loadingGenerate, setLoadingGenerate] = useState(false);
  const [loadingGradeSingle, setLoadingGradeSingle] = useState(false);
  const [loadingGradeAll, setLoadingGradeAll] = useState(false);
  const [loadingSemanticEval, setLoadingSemanticEval] = useState(false);
  const [loadingLangchainEval, setLoadingLangchainEval] = useState(false);
   // ✅ Added: confirmation checkbox for copyright compliance
  const [confirmed, setConfirmed] = useState(false);
  const updateAnswer = (index, value) => {
  setAnswers(prev => ({ ...prev, [index]: value }));
 
};

  // Convert answers object to array
const normalizedAnswers = questions.map((_, i) => answers[i] ?? "");
const normalizedFeedback = questions.map((q, i) => {
  const fb = feedback[i] || {};
  const userAnswer = answers[i] ?? "";

  return {
    question: fb.question || q.question,
    answer: userAnswer,                 // use actual user answer
    grade: userAnswer ? fb.grade || "No grade" : "Incorrect", // blank = incorrect
    feedback: userAnswer ? fb.feedback || "No feedback" : "You did not answer this question.",
    expected_answer: fb.expected_answer || "",
    type: fb.type || "",
    score: fb.score ?? 0,
  };
});
  // 🔹 Grade single answer

const handleGradeSingle = async () => {
  const q = questions[currentIndex];
  const answer = answers[currentIndex] || "";
  if (!q || !answer) return;

  try {
    setLoadingGradeSingle(true); // ✅ start spinner
    const result = await gradeSingleAnswer(q, answer);
    console.log("gradeSingleAnswer result:", result);

    const fbArray = result.feedback;

    if (Array.isArray(fbArray) && fbArray.length > 0) {
      const item = fbArray[0]; // ✅ backend returns array of 1

      // ✅ CHANGE: store full object, not just strings
      setFeedback((prev) => ({
        ...prev,
        [currentIndex]: {
          question: item.question,
          answer: item.answer,
          grade: item.grade || "No grade",
          feedback: item.feedback || "No feedback",
          expected_answer: item.expected_answer || "" // 🔹 NEW
        }
      }));

      console.log("Stored feedback:", {
        question: item.question,
        answer: item.answer,
        grade: item.grade,
        feedback: item.feedback
      });
    }
  } catch (err) {
    console.error("Failed to grade single answer:", err);
  }
  finally {
    setLoadingGradeSingle(false); // ✅ stop spinner
  }
};



const handleGradeAll = async () => {
  const unanswered = questions
    .map((q, idx) => ({ idx, q }))
    .filter(({ idx }) => !feedback[idx]);
try {
    setLoadingGradeAll(true); // ✅ start spinner
  if (unanswered.length > 0) {
    const qList = unanswered.map((u) => u.q);
    const aList = unanswered.map((u) => answers[u.idx] || "");
    const result = await gradeAllAnswers(qList, aList);

    const newFeedback = { ...feedback };

    // ✅ CHANGE: store full object (question, answer, grade, feedback)
    if (Array.isArray(result.feedback)) {
      result.feedback.forEach((item, i) => {
        const idx = unanswered[i].idx;
        newFeedback[idx] = {
          question: item.question,
          answer: item.answer,
          grade: item.grade || "No grade",
          feedback: item.feedback || "No feedback",
          expected_answer: item.expected_answer || "" // 🔹 NEW
        };
      });
    }

    setFeedback(newFeedback);
  } 

  setShowSummary(true);
}
catch (err) {
    console.error("Failed to grade single answer:", err);
  }
  finally {
    setLoadingGradeAll(false); // ✅ stop spinner
  }

};

const handleSemanticEvaluate = async () => {
  try {
    setLoadingSemanticEval(true); // ✅ start spinner
    const qList = questions;
    const aList = questions.map((_, i) => answers[i] || "");

    const result = await semanticEvaluate(qList, aList); // must return {results, summary}
    console.log("Semantic Evaluated results:", result);
   
    const evaluatedArray = (
    result?.results ||
    result?.["results using semantic similarity"] ||  []
).map((item) => ({
  question: item.question,
  answer: item.answer || "",
  expected_answer: item.expected_answer || "",
  type: item.type || "",
  score: typeof item.score === "number" ? item.score : Number(item.score || 0),
  grade: item.grade || (item.score >= 0.9 ? "Correct" : "Incorrect"),
  feedback: item.feedback || "No feedback provided.",
}));
    console.log("Semantic Evaluated  evaluatedArray:",  evaluatedArray);
    // ✅ Save as array
    setEvaluationResults(evaluatedArray);
    setEvaluationSummary(result.summary || null);
    setEvalutionType("Semantic Similarity");
  } catch (err) {
    console.error("Error during semantic evaluation:", err);
  }
  finally {
    setLoadingSemanticEval(false); // ✅ stop spinner
  }
  //setEvaluationSummary(true);
};

const handleLangchainEvaluate = async () => {
  try {
    setLoadingLangchainEval(true); // ✅ start spinner
    const qList = questions;
    const aList = questions.map((_, i) => answers[i] || "");

    const result = await langchainEvaluate(qList, aList); // must return {results, summary}
    console.log("Langchain Evaluated results:", result);

    const evaluatedArray = (
  result?.results ||
  result?.["results using langachain evaluation"] ||
  []
).map((item) => ({
  question: item.question,
  answer: item.answer || "",
  expected_answer: item.expected_answer || "",
  type: item.type || "",
  score: typeof item.score === "number" ? item.score : Number(item.score || 0),
  grade: item.grade || (item.score >= 0.9 ? "Correct" : "Incorrect"),
  feedback: item.feedback || "No feedback provided.",
}));

    // ✅ Save as array
    setEvaluationResults(evaluatedArray);
    setEvaluationSummary(result.summary || null);
    setEvalutionType("Langchain");
  } catch (err) {
    console.error("Error during langchain evaluation:", err);
  }
  //setEvaluationSummary(true);
  finally {
    setLoadingLangchainEval(false); // ✅ stop spinner
  }
};

const handleGenerate = async () => {
  setEvaluationResults(null);
  setEvaluationSummary(null);
  setEvalutionType(null);
  try {
    // Before calling the API:
    if (!confirmed) {
      alert("Please confirm you will not use copyrighted text.");
    return;
    }
    setLoadingGenerate(true); // ✅ start spinner
    // 🔹 First reset the cache
    //const resetResult = await resetCache();
    //console.log("Cache reset:", resetResult);

    // 🔹 Store chapter (so grading has context)
    await storeChapter("book123", 1, chapterText);
    console.log("Chapter stored successfully\n");

    // 🔹 Now generate fresh questions
    const result = await generateQuestions(chapterText);
    const safeQuestions = Array.isArray(result?.questions) ? result.questions : [];
    console.log("Received from backend:\n", safeQuestions);

    // 🔹 Update state with fresh data
    setQuestions(safeQuestions);
    setCurrentIndex(0);
    setAnswers({});
    setFeedback({});
    setGrade({});
    setShowSummary(false);
    setEvaluationResults(false);
    setEvalutionType(false);
    setEvaluationSummary(false);

  } catch (error) {
    console.error("Error generating questions:", error);
    setQuestions([]);
  }
  finally {
    setLoadingGenerate(false); // ✅ stop spinner
  }
};

const handleBackToStart = () => {
  setShowSummary(false);
  setQuestions([]);
  setAnswers({});
  setFeedback({});
  setGrade("");
  setEvaluationResults({});
  setEvaluationSummary(null);
  setEvalutionType(null);
  setCurrentIndex(0);
};

useEffect(() => {
    const handler = (e) => {
      if (
        e.message &&
        e.message.includes(
          "ResizeObserver loop completed with undelivered notifications."
        )
      ) {
        console.warn("⚠️ Ignored ResizeObserver loop warning");
        return;
      }
      console.error(e);
    };

    window.addEventListener("error", handler);
    window.addEventListener("unhandledrejection", handler);

    return () => {
      window.removeEventListener("error", handler);
      window.removeEventListener("unhandledrejection", handler);
    };
  }, []);


  return (
    <Container maxWidth="md" sx={{ py: 4 }}>
      <Typography variant="h4" gutterBottom>
        Learning Assistant
      </Typography>
      
       {!showSummary && (
        <>
         {/* ✅ Added: Copyright disclaimer */}
          <ChapterViewer text={chapterText} onTextChange={setChapterText} />
          <div className="mt-3 text-sm text-gray-600 bg-yellow-50 border border-yellow-300 rounded-md p-3">
  ⚠️    <strong>Disclaimer:</strong> Please enter only your own writing, open educational resources, or public domain material. 
        Do <u>not</u> upload copyrighted books, textbooks, or articles. 
        By using this tool, you agree that you have permission to use the submitted text.
        </div>
         {/* ✅ Added: Confirmation checkbox */}
        <label className="flex items-center space-x-2 mt-3">
        <input 
          type="checkbox" 
          checked={confirmed} 
          onChange={() => setConfirmed(!confirmed)} 
        />
        <span className="text-sm">I confirm this text is not copyrighted.</span>
        </label>
         {/* Generate button */}
          <Box sx={{ display: 'inline-flex', alignItems: 'center', gap: 1 }}>
            <QuestionGeneratorButton
              chapterText={chapterText}
              onGenerate={handleGenerate}
              disabled={loadingGenerate} // optional
            />
            {loadingGenerate && <CircularProgress size={20} />}
          </Box>

          {questions.length > 0 && (
            <QuizRotation
              questions={questions}
              currentIdx={currentIndex}
              setCurrentIdx={setCurrentIndex}
              answers={answers}
              //setAnswers={setAnswers}
              setAnswers={updateAnswer}  // ✅ pass wrapper
              grade = {grade}
              feedback={feedback}             
              handleSingleGrade={handleGradeSingle}
              handleGradeAll={handleGradeAll}
              loadingGradeSingle = {loadingGradeSingle}
              loadingGradeAll = {loadingGradeAll}
            />
          )}
        </>
      )}      
         {showSummary && (
        <Box sx={{ mt: 4 }}>
          <FeedbackSummary
            questions={questions}
            answers={normalizedAnswers}
            feedback={normalizedFeedback}
            grade={grade}
            
            onSemanticEvaluate = {handleSemanticEvaluate}
            onLangchainEvaluate = {handleLangchainEvaluate}            
            loadingSemanticEval={loadingSemanticEval}
            loadingLangchainEval={loadingLangchainEval}
            //onBack={() => setShowSummary(false)}   // ✅ add this
            onBack={handleBackToStart}   // ✅ now passes reset logic
          />          
        </Box>
      )}

      {/* {!loading && questions.length > 0 && evaluationSummary && ( */}
      {evaluationSummary && (
      <Box sx={{ mt: 4 }}>
      <Evaluation        
        evaluationResults={evaluationResults}  // ✅ corrected
        evaluationSummary={evaluationSummary} // add this
        evaluationType = {evaluationType}        
      />
      </Box>
      )}      
    {/* ✅ Added: Legal footer */}
      <footer className="text-center text-xs text-gray-500 mt-6 py-3 border-t">
        © {new Date().getFullYear()} ReadNQuiz. Educational use only. Do not
        upload copyrighted materials.
      </footer> 
    </Container>
  );
 }